import React from "react";

export default function SkeletonLoader() {
  return (
    <div className="grid animate-pulse grid-cols-5 gap-4 border-b border-[#0075FF1A] px-[40px]">
      <div className="py-[20px]">
        <div className="h-[17.64px] w-[80%] rounded bg-[#e0e0e0]"></div>
      </div>
      <div className="py-[20px]">
        <div className="h-[17.64px] w-[60%] rounded bg-[#e0e0e0]"></div>
      </div>
      <div className="py-[20px]">
        <div className="h-[17.64px] w-[70%] rounded bg-[#e0e0e0]"></div>
      </div>
      <div className="py-[20px]">
        <div className="h-[17.64px] w-[90%] rounded bg-[#e0e0e0]"></div>
      </div>
      <div className="py-[20px]">
        <div className="h-[17.64px] w-[50%] rounded bg-[#e0e0e0]"></div>
      </div>
    </div>
  );
}
